interface ISiteElementFilterArrayDefaultRendererConfig {
    isSingleSelect: boolean;
}

class SiteElementFilterArrayDefaultRenderer
    extends QueryElement<HTMLElement>
    implements ISiteElementFilterRenderer, ISiteElementCheckItem {
    
    private readonly _filter: SiteElementFilterArray;
    private readonly _value: ISiteFilterItem;
    private readonly _config: ISiteElementFilterArrayDefaultRendererConfig;
    private readonly _clear: SiteElementButton;
    private _index: number;
    private _container: QueryElement<HTMLElement>;
    private _state: {
        showMore: boolean,
        isHide: boolean
    };
    private _maxVisibleItems: number;

    private readonly _type: SiteElementFilterArrayTypes;

    static getDefaultState() {
        return {
            showMore: false,
            isHide: false
        };
    }
    
    constructor(filter: SiteElementFilterArray, value: ISiteFilterItem, type: SiteElementFilterArrayTypes, amount: number | undefined, state: any) {
        super(document.createElement("DIV"));

        this._filter = filter;
        this._value = value;
        this._index = 0;
        this._state = state;
        this._type = type;
        this._config = filter.getConfig<ISiteElementFilterArrayDefaultRendererConfig>({
            isSingleSelect: false
        });
        this._maxVisibleItems = amount || 10;

        this.addClass("element-filter-default");

        var header = QueryElement.QueryElement("H2")
            .setText(value.name);
        header.on("click", () => {
            if (this._state.isHide)
                this.removeClass("hide");
            else
                this.addClass("hide");
            
            this._state.isHide = !this._state.isHide;
        });
        if (this._state.isHide)
            this.addClass("hide");

        this._container = QueryElement.QueryElement("DIV")
            .addClass("container");
        this.showMore(this._state.showMore);

        this.append(header);
        this.append(this._container);
        
        // Append clear button
        let clear = new SiteElementButton({
            "icon": "clear",
            "title": "Reset"
        });
        clear.addClass("reset");
        clear.on("click", () => {
            this._filter.removeValues();
            this._filter.updateFilterModel(true);
        });
        this.append(clear);
        this._clear = clear;

        this.checkFilter();
    }

    addValue(value: ISiteFilterItemValue): void {
        if (this._config.isSingleSelect) {
            this._filter.removeValues();
            this.query(".element-filter-checkitem")
                .all<SiteElementCheckItem, any>(a => a.makeInactive());
        }

        this._filter.addValue(value.filterValue);
        this._filter.updateFilterModel(false);

        this.checkFilter();
    }
    removeValue(value: ISiteFilterItemValue): void {
        this._filter.removeValue(value.filterValue);
        this._filter.updateFilterModel(false);

        this.checkFilter();
    }
    checkFilter(): void {
        if (!this._filter.hasValue())
            this._clear.addClass("hidden");
        else
            this._clear.removeClass("hidden");
    }
    containsValue(value: ISiteFilterItemValue): boolean {
        return this._filter.containsValue(value.filterValue);
    }

    showMore(show: boolean) {
        this._state.showMore = show;
        for(let child of this._container.children()) {
            child.remove();
        }

        let buttonConfig : ISiteElementButtonConfig;
        if (show)
            buttonConfig = {
                title: "",
                icon: "keyboard_arrow_up"
            };
        else
            buttonConfig = {
                title: "",
                icon: "keyboard_arrow_down"
            };

        let button = new SiteElementButton(buttonConfig);
        button.on("click", () => {
            this.showMore(!show);
        });

        this._index = 0;
        this._container.append(this.renderChilds(this._value.items, show));
        
        if (this._index > this._maxVisibleItems)
            this._container.append(button);
    }

    renderChilds(items: ISiteFilterItemValue[], show: boolean) {
        let container = QueryElement.QueryElement("UL");
        
        for(let item of items) {
            if (this._index++ < this._maxVisibleItems || show)
            {
                let containerItem = QueryElement.QueryElement("LI");
                
                switch(this._type)
                {
                    default:
                        new SiteElementCheckItem(this, item)
                            .appendTo(containerItem);
                        break;
                    case  "color":
                        new SiteElementCheckColorItem(this, item as ISiteFilterColorItemValue)
                            .appendTo(containerItem);
                        break;
                }
                
                if (item.childs != null) {
                    this.renderChilds(item.childs, show)
                        .appendTo(containerItem);
                }

                container.append(containerItem);
            }
            else
            {
                break;
            }
        }

        return container;
    }

    getState() {
        return this._state;
    }
}
